import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Typography, Switch, FormControlLabel } from "@mui/material";

import { fetchCustomer } from "../../../redux/slices/universalSlice";
import { editBank } from "../../../redux/slices/universalSlice";

import CardTypography from "../../../components/Typography/CardTypography";
import Input from "../../../components/fields/Input";
import LoaderButton from "../../../components/buttons/LoaderButton";

import Container from "../../../components/Grid/Container";
import Row from "../../../components/Grid/Row";
import Column from "../../../components/Grid/Column";

import ColumnInset from "../../../components/Grid/ColumnInset";
import ColumnOutset from "../../../components/Grid/ColumnOutset";
import ColumnHeading from "../../../components/Grid/ColumnHeading";

const buttonStyle = {
  marginTop: 2,
  background: "#e0e0e0",
  color: "#333",
  boxShadow: "4px 4px 8px rgba(0, 0, 0, 0.2), -4px -4px 8px rgba(255, 255, 255, 0.5)",
  "&:hover": {
    background: "#f0f0f0",
    boxShadow: "inset 2px 2px 5px rgba(0, 0, 0, 0.1), inset -2px -2px 5px rgba(255, 255, 255, 0.5)",
  },
};

function EditBank({ customer_uuid, onBack }) {
  const dispatch = useDispatch();
  const user_uuid = useSelector((state) => state.auth.user_uuid);

  const [formData, setFormData] = useState({
    customer_account_number: "",
    customer_account_holder: "",
    customer_bank: "",
    customer_branch_code: "",
    bank_verified: false,
    bank_verified_message: "",
  });

  const { customer } = useSelector((state) => state.universalSlice);

  useEffect(() => {
    if (customer_uuid) {
      dispatch(fetchCustomer({ customer_uuid }));
    }
  }, [customer_uuid, dispatch]);

  useEffect(() => {
    setFormData({
      customer_account_number: customer.customer_account_number || "",
      customer_account_holder: customer.customer_account_holder || "",
      customer_bank: customer.customer_bank || "",
      customer_branch_code: customer.customer_branch_code || "",
      bank_verified: customer.bank_verified || false,
      bank_verified_message: customer.bank_verified_message || "",
    });
  }, [customer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleToggle = (field) => {
    setFormData((prev) => ({ ...prev, [field]: !prev[field],
      bank_verified_message: '', }));
  };
  const handleSubmit = async () => {
    try {
      const result = await dispatch(editBank({ user_uuid, customer_uuid, data: formData })).unwrap();
    } catch (error) {
      console.error("Error updating customer:", error);
    } finally {
      onBack();
    }
  };

  return (
    <Container>
      <Row>
        <ColumnHeading xs={12}>
          <Button onClick={onBack} variant="contained" color="primary" sx={{ marginBottom: 2 }}>
            Back to Landlord Management
          </Button>
          <CardTypography variant={"h3"}>Edit Bank Details</CardTypography>
        </ColumnHeading>
      </Row>

      <Row>
        <ColumnOutset xs={3}></ColumnOutset>
        <ColumnInset xs={6}>
          <Input label="Account Number" placeholder="Account Number" name="customer_account_number" value={formData.customer_account_number} onChange={handleChange} />
          <Input label="Account Holder" placeholder="Account Holder" name="customer_account_holder" value={formData.customer_account_holder} onChange={handleChange} />
          <Input label="Bank" placeholder="Bank" name="customer_bank" value={formData.customer_bank} onChange={handleChange} />
          <Input label="Branch Code" placeholder="Branch Code" name="customer_branch_code" value={formData.customer_branch_code} onChange={handleChange} />

          <FormControlLabel
            control={
              <Switch
                checked={formData.bank_verified}
                onChange={() => handleToggle("bank_verified")}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "green",
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "green",
                  },
                  "& .MuiSwitch-switchBase": {
                    color: "red",
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: formData.bank_verified ? "green" : "red",
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  color: "#333",
                  fontWeight: "bold",
                }}
              >
                Bank Verified
              </Typography>
            }
          />
          <Input label="Customer Verified Message" placeholder="Bank Verified Message" name="bank_verified_message" value={formData.bank_verified_message} onChange={handleChange} />

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            <LoaderButton buttonText="Save" onClick={handleSubmit} />
            <Box sx={{ marginLeft: "auto" }}>
              <LoaderButton buttonText="Cancel" onClick={onBack} />
            </Box>
          </Box>
        </ColumnInset>
        <ColumnOutset xs={3}></ColumnOutset>
      </Row>
    </Container>
  );
}

export default EditBank;
